import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ModelType } from '@shared/constants/model-type.enum';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  constructor(private apiService: ApiService) {}

  getPredictordownloadCSV(modelType: ModelType): Observable<Blob> {
    return this.apiService.getBlob(`Reports/PredictorCSV/`, modelType);
  }

  getComponentDecoder(modelType: ModelType): Observable<Blob> {
    return this.apiService.getBlob('Reports/ComponentDecoder', modelType);
  }

  getComponentCorrectionExamples(modelType: ModelType): Observable<Blob> {
    return this.apiService.getBlob('Reports/ComponentCorrectionExamples', modelType);
  }

  downloadFile(response: Blob, filename: string): void {
    const url = window.URL.createObjectURL(response);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
}
